import firebaseInstance from "../../../util/firebase";

export default {
  saveBillingDetails: (state, item) => {
    console.log("saveBillingDetails", item.uid);
    // firebaseInstance.database().ref('users/' + item.uid).update(item, () => {
    //   console.log('saved billing details')
    //   // state.commit('SAVE_USER_DATA', item)
    // }).catch((error) => {
    //   console.log('Error saveBillingDetails', error)
    // })
  },
  updateBillingInfo0(state, item) {
    console.log("updateBillingInfo0", item);
    var data = item;

    axios
      .get("/updatebillingcard", {
        params: {
          format: "json",
          data
        }
      })
      .then(function(response) {
        console.log("updateBillingInfo0 RESPONSE", response);
      })
      .catch(function(error) {
        console.log("updateBillingInfo0 ERROR", error.response);
      })
      .then(function() {
        // always executed
      });
  },
  updateBillingInfo(state, item) {
    console.log("updateBillingInfo", item);
    var data = item;

    axios
      .get("/updatebillinginfo", {
        params: {
          format: "json",
          data
        }
      })
      .then(function(response) {
        console.log("updateBillingInfo RESPONSE", response);
      })
      .catch(function(error) {
        console.log("updateBillingInfo ERROR", error.response);
      })
      .then(function() {
        // always executed
      });
  },
  saveProfileImage: (state, item) => {
    console.log("item", item);
    firebaseInstance
      .storage()
      .ref("users/" + item.uid + "/images/" + item.file.name)
      .put(item.file)
      .then(snapshot => {
        console.log("Uploaded a blob or file!", snapshot);
        firebaseInstance
          .storage()
          .ref()
          .child("users/" + item.uid + "/images/" + item.file.name)
          .getDownloadURL()
          .then(url => {
            console.log("url", url);
            firebaseInstance
              .database()
              .ref("users/" + item.uid + "/profileImage")
              .set(url)
              .then(() => {
                console.log("Profile image path saved");
                var object = { url: url };
                state.commit("SAVE_PROFILE_IMAGE", object);
              })
              .catch(error => {
                console.log(error, "Error saving path to profile image");
              });
          })
          .catch(error => {
            console.log(error, "Error getting profile image");
          });
      });
  },
  saveProfile: (state, item) => {
    return new Promise((resolve, reject) => {
      firebaseInstance
        .database()
        .ref("users/" + item.uid)
        .update(item, () => {
          firebaseInstance
            .database()
            .ref("users/" + item.uid)
            .once("value", snap => {
              var data = snap.val();
              state.commit("SAVE_USER_DATA", data);
              resolve(true);
            });
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deletePhoto: (state, item) => {
    firebaseInstance
      .database()
      .ref("users/" + item.uid + "/profileImage")
      .set("")
      .then(() => {
        console.log("Profile image path removed");
        var object = { url: null };
        state.commit("SAVE_PROFILE_IMAGE", object);
      })
      .catch(error => {
        console.log(error, "Error deleting image");
      });
  }
};
